var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v("You are about to move "),
      _c("span", { staticClass: "event-name" }, [
        _vm._v(_vm._s(_vm.moveEventData.eventName))
      ]),
      _vm._v(" to "),
      _c("span", { staticClass: "event-status" }, [
        _vm._v(_vm._s(_vm.moveEventData.updateStatus))
      ])
    ]),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v(
        "If this client has email notifications on, they will recieve an email regarding the move."
      )
    ]),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24432e6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24432e6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/MoveEvent.vue
// module id = 1434
// module chunks = 1